import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, apiErrorMessage } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = logged out, object = user

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      setUser(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const login = async (email, password) => {
    try {
      const { data } = await api.post("/auth/login", { email, password });
      setUser(data);
      return { success: true, user: data };
    } catch (err) {
      return { success: false, error: apiErrorMessage(err) };
    }
  };

  const register = async (name, email, password, referralCode) => {
    try {
      const { data } = await api.post("/auth/register", { name, email, password, referral_code: referralCode || null });
      setUser(data);
      return { success: true };
    } catch (err) {
      return { success: false, error: apiErrorMessage(err) };
    }
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } finally {
      setUser(false);
    }
  };

  return (
    <AuthContext.Provider value={{ user, login, register, logout, refresh }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
